import { PlanSiteService } from './../../Service/plan-site.service';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Global } from 'src/app/Service/global.service';
import { takeUntil } from 'rxjs/operators';
import * as _ from 'lodash';

@Component({
  selector: 'app-plan-site',
  templateUrl: './plan-site.component.html',
  styleUrls: ['./plan-site.component.scss']
})
export class PlanSiteComponent implements OnInit {
  currentLg ;
  MenuData=  [];
  MenuNiveau0 = [];
  constructor(private global: Global,  private service: PlanSiteService, private router: Router) { }

  ngOnInit(): void {
    this.global.CurentLanguage.pipe(takeUntil(this.global.navigationEnd)).subscribe(lg => {
      this.currentLg = lg;
      this.service.getAllMenu(lg.url).subscribe(datas => {
       this.MenuData = datas['value'];
       this.MenuNiveau0 = this.getSousMenu(null);
      });
    });
  }
  getSousMenu(id){
    return _.orderBy(this.MenuData.filter(n=>n.ParentId==id), ['Ordre'], ['asc']);
  }

}
